import React from "react";
import "./Badge.scss";

const Badge = ({ className, kind, label }) => {
	return (
		<div className={`custom-badge ${className ? className : ""} ${kind ? kind : ""}`}>
			<div className="text text-body--4">{label}</div>
		</div>
	);
};

export default Badge;
